<template>
  <div class="selectObject">
    <div v-if="noGrade">
      <div class="selectHead">
        布置作业
        <div class="stepBar fr">
          <img src="../assets/img/step1.png" alt="">
          <p>
            <span class="active">布置对象</span>
            <span>选择内容</span>
            <span>作业留言</span>
          </p>
        </div>
      </div>
      <div class="selectContent clearfix">
        <div class="leftBox fl">
          <div class="classbox" :class="{ active:index == isActive }" v-for="(item, index) in grads" :key="index" v-if="item.count != 0">
            <!-- 判断班级的三种点击状态，分别为不选，半选，全选 -->
            <em @click.stop="selectedGradFun(index)" :class="{'': item.selNum == 0, 'is-indeterminate': item.selNum < item.count && item.selNum > 0, 'allSelected': item.selNum == item.count && item.selNum != 0}"></em>
            <p @click.stop="selectedGradFun(index, true)">
              <span>{{item.className}}</span>
              <span class="checkCount fr">{{item.selNum}} / {{item.count}}</span>
            </p>
          </div>
        </div>
      
        <div class="rightBox fr">
          <div class="checkBox clearfix" v-for="(item, index) in groups" :key="index">
            <div class="header">
              <div class="groups fl" @click="selectGroup(index)">
                <!-- 判断分组的三种点击状态，分别为不选，半选，全选 -->
                <em :class="{'': item.selNum == 0, 'is-indeterminate': item.selNum < item.count && item.selNum > 0 , 'allSelected': item.selNum == item.count && item.selNum != 0}"></em>
                <p>
                  <span style="margin-right:6px">{{item.title}}</span>
                  <span style="font-size:12px;color:#999">{{item.selNum}} / {{item.count}}</span>
                </p>
              </div>
              <span class="teamShow fr" :class="{'arrow-up': item.teamShow, 'arrow-down': !item.teamShow}" @click="showStu(index)">{{!item.teamShow
                ? '展开': '收起'}}</span>
            </div>
            <ul class="students clearfix" v-show="item.teamShow">
              <li v-for="(sItem, sIndex) in item.data" :key="sIndex">
                <span :class="{'active':sItem.checked}" @click="selectedStudentFun(index, sIndex)">{{sItem.userName}}</span>
              </li>
            </ul>
          </div>
          <div>
          </div>
        </div>
      </div>
      <div class="nextOne">
        <button class="button" :class="{'gray': selectNum == 0, 'green': selectNum > 0}" @click="nextOne">下一步</button>
      </div>
    </div>
    <div v-else class="noData">
      <img src="./../assets/img/null.png" class="noGrade">
      <span>没有可以布置作业的班级</span>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import Vue from "vue";
import fetch from "./../fetch";
import { mapGetters, mapActions } from "vuex";
import { brandId } from "./../config";
export default {
  data() {
    return {
      noGrade: true,
      grads: [],
      groups: [],
      isActive: 0,
      selectNum: 0
    };
  },

  created() {
    this.$nextTick(() => {
      this.setWorks({});
      let studentsListData = window.sessionStorage.getItem('studentsTemp')
      if (studentsListData) {
        this.grads = JSON.parse(studentsListData)
        this.groups = this.grads[0].students;
        this.getSelectedNum();
      } else {
        let params = {
          userRole: 2,
          exists: 1
        };
        this.getClass(params);
      }
    });
  },
  methods: {
    ...mapActions(["setWorks"]),
    getClass(params) {
      fetch
        .grads(params)
        .then(res => {
          if (!res) {
            this.noGrade = false
            return false;
          }
          return res;
        })
        .then(grads => {
          if (!grads || (grads.data && !grads.data.length)) {
            this.noGrade = false
            return false;
          }
          let classIds = [];
          for (let i = 0; i < grads.data.length; i++) {
            classIds.push(grads.data[i].classId);
          }
          let param = {
            classIds: classIds.join(","),
            userRole: 1
          };
          this.getStuList(param);
        });
    },

    // 获取班级数据
    getStuList(param) {
      fetch.getMemberlist(param).then(res => {
        if (!res) {
          return false;
        }
        this.grads = res.data;
        this.getGrads(false);
        this.groups = this.grads[0].students;
      });
    },
    // 遍历班级数据，添加选中标识，得到班级下面的分组数组
    getGrads(checked) {
      let grads = [];
      this.grads.map((item, index) => {
        item.checked = checked; // 选中标识
        item.selNum = 0;
        let students = item.data;
        const { newStu, student_count } = this.getGroups(students, checked);
        item.students = newStu;
        item.count = student_count;
        grads.push(item);
      });
      this.grads = grads;
      window.sessionStorage.setItem("studentsListData", JSON.stringify(this.grads));
      window.sessionStorage.setItem("studentsTemp", JSON.stringify(this.grads));
    },
    // 获取班级的分组，对分组进行处理
    getGroups(students, checked) {
      let group = {};
      let newStu = [];
      let groupTitles = [];
      let student_count = 0;
      students.sort((a,b) => {
        return  a.userName.localeCompare(b.userName)
      })
      for (let index = 0, len = students.length; index < len; index++) {
        let item = students[index];
        if (item.userRole === 2) {
          // 过滤掉教师本身
          continue;
        }
        item.checked = checked;
        // 分组判断处理
        // 1.如果班级下面学生有分组就显示对应的分组，如果没有就列为未分组
        // 2.未分组列成员名单默认不展开
        item.teamName = item.teamName || "未分组";
        const same_index = groupTitles.indexOf(item.teamName);
        if (index === 0 || same_index < 0) {
          group = {
            title: item.teamName,
            data: [item],
            count: 1,
            checked,
            teamShow: false,
            selNum: 0
          };
          groupTitles.push(group.title);
          newStu.push(group);
        } else {
          let group = newStu[same_index];
          group.data.push(item);
          group.count += 1;

          newStu[same_index] = group;
        }
        student_count++;
      }
      return { newStu, student_count };
    },
    setGroups(groups, checked) {
      groups.map(item => {
        item.checked = checked;
        item.selNum = checked ? item.count : 0;
        item.data = this.setStudents(item.data, checked);
      });
      this.groups = groups;
      return groups;
    },
    // 班级的点击事件处理
    selectedGradFun(index, showTag) {
      const grad = this.grads[index];
      const checked = !grad.checked;
      this.isActive = index;

      if (!checked && showTag) {
        this.groups = grad.students;
        return;
      }
      const groups = this.setGroups(grad.students, checked);
      const selNum = checked ? grad.count : 0;
      this.grads[index] = Object.assign(grad, {
        checked,
        students: groups,
        selNum
      });
      this.getSelectedNum();
    },

    setStudents(students, checked) {
      students.map(item => {
        item.checked = checked;
      });
      return students;
    },
    // 分组的点击事件处理
    selectGroup(index) {
      const group = this.groups[index];
      const checked = !group.checked;
      const selNum = checked ? group.count : 0;
      const data = this.setStudents(group.data, checked);
      this.grads[this.isActive].selNum +=
        checked && group.selNum < group.count
          ? group.count - group.selNum
          : -1 * group.selNum;
      this.grads[this.isActive].checked = true;
      this.groups[index] = Object.assign(group, { checked, data, selNum });
      this.getSelectedNum();
    },
    // 分组下面学生成员的点击事件处理
    selectedStudentFun(index, sIndex) {
      const group = this.groups[index];
      const student = group.data[sIndex];
      const checked = !student.checked;
      const selNum = group.selNum + (checked ? 1 : -1);
      group.data[sIndex].checked = checked;
      this.groups[index] = Object.assign(group, {
        selNum,
        checked: selNum == group.count
      });
      this.grads[this.isActive].selNum += checked ? 1 : -1;
      this.grads[this.isActive].checked = true;
      this.getSelectedNum();
    },
    // 学生成员的显示与隐藏
    showStu(index) {
      const group = this.groups[index];
      this.groups[index] = Object.assign(group, { teamShow: !group.teamShow });
    },
    getSelectedNum() {
      let count = 0;
      this.grads.map(item => {
        if (item.selNum > 0) {
          count++;
        }
      });
      this.selectNum = count;
    },
    // 下一步操作
    nextOne() {
      if (!this.selectNum) {
        this.$toast("请选择布置对象");
        return false;
      }
      const classList = []; // 布置作业班级集合  以班级为单位,
      const userList = []; // 布置作业班级集合  以学生个人为单位,
      const classIdArr = [];
      let target = "";
      // debugger
      this.grads.forEach(item => {
        let grad = {};
        if (item.checked && item.selNum) {
          grad = {
            schoolId: item.schoolId,
            classId: item.classId,
            className: item.className,
            selectStudentLength: item.selNum,
            studentCount: item.count
          };
          let groupList = item.students;
          groupList = Object.keys(groupList)
            .sort((a, b) => {
              const group_first = groupList[a];
              const group_second = groupList[b];
              return (
                group_second.selNum / group_second.count -
                group_first.selNum / group_first.count
              );
            })
            .map(index => groupList[index]);
          classIdArr.push(grad.classId);
          if (item.selNum < item.count) {
            let userList = [];
            target += ";" + item.className + "-";
            groupList.map(gItem => {
              let user = {};
              let isGroupChecked = false;
              if (gItem.selNum === gItem.count) {
                isGroupChecked = true;
                target += gItem.title + ",";
              } else if (gItem.selNum > 0) {
                // target += item.className + "-";
              }
              gItem.data.map(sItem => {
                if (sItem.checked) {
                  user = {
                    userId: sItem.userId,
                    userName: sItem.userName
                  };
                  if (!isGroupChecked) {
                    target += sItem.userName + ",";
                  } else {
                    user.groupName = gItem.title;
                  }
                  userList.push(user);
                }
              });
              // target = target.substring(0, target.length - 1) + ";";
            });
            grad.userList = userList;
          } else {
            target += ";" + item.className;
          }
          classList.push(grad);
        }
      });
      console.log('this', this.grads)
      window.sessionStorage.setItem("studentsTemp", JSON.stringify(this.grads));
      const classIdstr = classIdArr.join(","); // 班级ID拼接
      target = target.substring(1, target.length).replace(",;", ";");
      fetch
        .getClassService({ classids: classIdstr, sId: 0, uId: brandId })
        .then(res => {
          console.log(res);
          if (!res) {
            return false;
          }
          if (res.data.length > 0 || classList.length < 2) {
            this.setWorks({ classList, target });
            window.sessionStorage.setItem("service", JSON.stringify(res.data));
            this.$router.push({
              path: "setHomework",
              query: { bookType: 1, classIdstr: classIdstr }
            });
          } else {
            this.$toast("所选班级使用的书籍不相同，您可以单个班级布置");
            return false;
          }
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// selectGrade.vue?07a3d99c